var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64405 0.799927C5.21188 0.799927 3.83837 1.36885 2.82567 2.38155C1.81297 3.39425 1.24405 4.76776 1.24405 6.19993V9.42733L0.607746 10.0636C0.481918 10.1895 0.396232 10.3498 0.361521 10.5244C0.326811 10.699 0.344633 10.8799 0.412736 11.0443C0.480839 11.2087 0.596165 11.3493 0.744134 11.4482C0.892103 11.5471 1.06607 11.5999 1.24405 11.5999H12.044C12.222 11.5999 12.396 11.5471 12.544 11.4482C12.6919 11.3493 12.8073 11.2087 12.8754 11.0443C12.9435 10.8799 12.9613 10.699 12.9266 10.5244C12.8919 10.3498 12.8062 10.1895 12.6803 10.0636L12.044 9.42733V6.19993C12.044 4.76776 11.4751 3.39425 10.4624 2.38155C9.44973 1.36885 8.07622 0.799927 6.64405 0.799927ZM6.64405 15.1999C5.92796 15.1999 5.24121 14.9155 4.73486 14.4091C4.22851 13.9028 3.94405 13.216 3.94405 12.4999H9.34405C9.34405 13.216 9.05958 13.9028 8.55324 14.4091C8.04689 14.9155 7.36013 15.1999 6.64405 15.1999Z",
    fill: "#49454F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.90a300b3713020cde6ac82672661b0fa.svg";
export { ForwardRef as ReactComponent };